import { render } from "./themes-profile-others-categories-offer.vue?vue&type=template&id=2543a0f7"
import script from "./themes-profile-others-categories-offer.vue?vue&type=script&lang=js"
export * from "./themes-profile-others-categories-offer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__